import {dspApi} from 'common/api/entitiesApi'
import {EntitySelector} from 'common/components/reloadable/EntitySelector'

export interface Props {
    value?: number | number[]
    onChange?: (value?: number | number[]) => void
    style?: React.CSSProperties
    placeholder?: string
    disabled?: boolean
    multiple?: boolean
}

export const DspSelector = ({value, onChange, style, disabled, placeholder, multiple}: Props) => {
    function loadEntity(id: number) {
        return dspApi.dsp(id)
    }

    function searchEntities(search: string, size: number, page: number) {
        return dspApi.dspList('name', 'asc', search, undefined, {
            query: {size, page}
        })
    }

    return (
        <EntitySelector
            value={value}
            onChange={onChange}
            loadEntity={loadEntity}
            searchEntities={searchEntities}
            placeholder={placeholder}
            disabled={disabled}
            style={style}
            errorText="Can't load DSPs"
            multiple={multiple}
        />
    )
}
